import { render, staticRenderFns } from "./PageSettleDashboard.vue?vue&type=template&id=0fcccad4&scoped=true"
import script from "./PageSettleDashboard.vue?vue&type=script&lang=js"
export * from "./PageSettleDashboard.vue?vue&type=script&lang=js"
import style0 from "./PageSettleDashboard.vue?vue&type=style&index=0&id=0fcccad4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcccad4",
  null
  
)

export default component.exports